module.exports = __webpack_public_path__ + "img/menuboard_mc_cafe.0861bf0b.webp";